import React, { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { HealthQuestionsSchema } from '@features/onboarding/schema/onboarding';
import Confetti from 'react-confetti';

// import {
//   FormField,
//   FormItem,
//   FormLabel,
//   FormControl,
// } from '@components/ui/form';
// import { Checkbox } from '@components/ui/checkbox';

import { HealthQuestion } from '@features/onboarding/components/6-health-question-form/interfaces';

interface CongratulationsStepProps {
  question: HealthQuestion;
  form: UseFormReturn<HealthQuestionsSchema>;
  onSubmit: () => void;
}

export const CongratulationsStep: React.FC<CongratulationsStepProps> = ({
  question,
  // form,
  onSubmit,
}) => {
  useEffect(() => {
    const childrenBlockParent = document.getElementById('childrenBlock')
      ?.parentNode as HTMLElement | null;
    const childrenBlock = document.getElementById('childrenBlock');

    if (childrenBlock && childrenBlockParent) {
      childrenBlockParent.style.padding = '0';
      childrenBlock.style.padding = '0';
    }

    return () => {
      if (childrenBlock && childrenBlockParent) {
        childrenBlockParent.style.padding = '';
        childrenBlock.style.padding = '';
      }
    };
  }, []);

  return (
    <div className="p-6 h-full relative flex items-center justify-center max-lg:min-h-80 overflow-hidden">
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        recycle={true}
        numberOfPieces={350}
        colors={[
          '#FF6B6B',
          '#4ECDC4',
          '#45B7D1',
          '#96CEB4',
          '#FFEAA7',
          '#DDA0DD',
          '#FFB347',
          '#98D8C8',
        ]}
      />
      <button
        onClick={onSubmit}
        className="bg-primary text-card rounded-4xl px-6 py-4 max-md:py-2 max-md:text-lg text-xl lg:text-2xl font-extrabold z-20"
      >
        {question.question}
      </button>
    </div>
  );
};
